import React, { useState, useEffect, useContext } from 'react'
import {
  Alert,
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Spinner,
} from 'react-bootstrap'
import postalCodes from '../data/postalCodes.json'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { Formik } from 'formik'
import * as yup from 'yup'
import { Helmet } from 'react-helmet'
import Cookies from 'js-cookie'
import { AuthContext } from './AuthContext'

const Settings = ({ currentUser, setCurrentUser, setLoginShow }) => {
  const { baseUrl, sendDiscordNotification } = useContext(AuthContext)
  const updateInfoUrl = '/api/crm/clinic/update'
  const getInfoUrl = '/api/crm/clinic/info'

  const [errShow, setErrShow] = useState({ show: false, msg: '' })
  const [success, setSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedCity, setSelectedCity] = useState('')
  const [codes, setCodes] = useState([
    '松山區',
    '信義區',
    '大安區',
    '中山區',
    '中正區',
    '大同區',
    '萬華區',
    '文山區',
    '南港區',
    '內湖區',
    '士林區',
    '北投區',
  ])
  const [selectedcode, setSelectedCode] = useState('')
  const [registrationInfo, setRegistrationInfo] = useState({
    name: '',
    tel: '',
    email: '',
    city: '',
    dist: '',
  })
  const [initialValues, setInitialValues] = useState({
    institutionName: registrationInfo.name,
    contactPhone: registrationInfo.tel,
    email: registrationInfo.email,
    city: registrationInfo.city,
    dist: registrationInfo.dist,
  })
  const navigate = useNavigate()

  const expiresTime = process.env.REACT_APP_EXPIRES_TIME
  const cookieOptions = { expires: expiresTime, secure: true }

  useEffect(() => {
    const newObj = postalCodes.filter((v) => v.city.includes(selectedCity))
    setCodes(newObj[0].codes)
  }, [selectedCity])

  useEffect(() => {
    const getUser = JSON.parse(Cookies.get('session'))
    const { hosp_id, inc_id, name, session } = getUser
    setCurrentUser({
      hosp_id: hosp_id,
      inc_id: inc_id,
      name: name,
      session: session,
    })

    // console.log('session', session)

    axios
      .get(baseUrl + getInfoUrl, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: '*/*',
          session: session || currentUser.session,
        },
      })
      .then((res) => {
        // console.log('getInfo', res)
        // TODO:存cookie
        if (res.data?.created_time) {
          const { name, tel, email, city, dist } = res.data
          setRegistrationInfo({
            name: name,
            tel: tel,
            email: email,
            city: city,
            dist: dist,
          })
          setSelectedCity(city)

          setCurrentUser((prevState) => {
            const newCurrentUser = { ...prevState, name: name }

            Cookies.set(
              'session',
              JSON.stringify(newCurrentUser),
              cookieOptions
            )
            return { ...prevState, name: name }
          })
        }
      })
      .catch((e) => {
        console.log('getInfo error', e)
        sendDiscordNotification(
          `getInfo Error \n Error: ${e} \n Session: ${session}`
        )
      })
  }, [success])

  useEffect(() => {
    setInitialValues({
      institutionName: registrationInfo.name,
      contactPhone: registrationInfo.tel,
      email: registrationInfo.email,
      city: registrationInfo.city,
      dist: registrationInfo.dist,
    })
    // console.log('initialValues', initialValues)
  }, [registrationInfo])

  const handleSubmit = (values) => {
    // e.preventDefault()
    setIsLoading(true)

    const requestBody = {
      name: values.institutionName,
      tel: values.contactPhone,
      email: values.email,
      city: values.city,
      dist: values.dist,
    }

    // console.log('updateInfo requestBody', requestBody)

    axios
      .post(baseUrl + updateInfoUrl, requestBody, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: '*/*',
          session: currentUser.session,
        },
      })
      .then((res) => {
        // TODO: 成功訊息
        // console.log('updateInfo', res)
        if (res.data?.message === '更新成功') {
          setSuccess(true)
          setTimeout(() => {
            setSuccess(false)
          }, 5000)
        } else if (res.data.error?.code === '50004') {
          setErrShow({
            show: true,
            msg: '請重新登入',
          })
          setLoginShow(true)
          setTimeout(() => {
            setErrShow({
              show: false,
              msg: '',
            })
          }, 5000)
        } else {
          setErrShow({
            show: true,
            msg: '伺服器忙碌中，請稍後再試',
          })
        }
      })
      .catch((e) => {
        console.log('e', e)
        setErrShow({
          show: true,
          msg: '伺服器忙碌中，請稍後再試',
        })
        sendDiscordNotification(
          `更新資料 Error \n Error: ${e} \n Session: ${
            currentUser.session
          } \n RequestBody: ${JSON.stringify(requestBody)}`
        )
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const vaildSchema = yup.object().shape({
    institutionName: yup.string().required('*機構名稱不得空白'),
    contactPhone: yup.string().required('*連絡電話不得空白'),
    email: yup.string().email('*電子郵件格式有誤').required('*Email 不得空白'),
    city: yup
      .string()
      .required('*請選擇所在縣市')
      .oneOf(
        postalCodes.map((v) => v.city),
        '*請選擇所在縣市'
      ),
    dist: yup
      .string()
      .required('*請選擇所在鄉鎮(市)區')
      .oneOf(
        codes.map((v) => v),
        '*請選擇所在鄉鎮(市)區'
      ),
  })
  // TODO: 要先顯示舊的資訊
  return (
    <>
      <Helmet>
        <title>更新資料 | HA! CRM</title>
      </Helmet>
      <Container className="settings">
        <Row
          className="justify-content-md-center align-items-center "
          style={{ height: '100vh' }}
        >
          <Col sm={8}>
            <Card>
              <Card.Header>更新機構基本資料</Card.Header>
              <Card.Body>
                <Formik
                  validationSchema={vaildSchema}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    // console.log('onSubmit', values)
                    setSubmitting(true)
                    handleSubmit(values)
                    setTimeout(() => {
                      resetForm()
                      setSubmitting(false)
                    }, 5000)
                  }}
                  initialValues={initialValues}
                  enableReinitialize={true}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => {
                    const handleCityChange = (e) => {
                      handleChange(e) // 调用Formik的handleChange
                      setSelectedCity(e.target.value) // 调用你自己的setSelectedCity函数
                    }
                    const handleDistChange = (e) => {
                      handleChange(e)
                      setSelectedCode(e.target.value)
                    }

                    return (
                      <Form onSubmit={handleSubmit}>
                        {/* {console.log('values', values)} */}

                        <Row>
                          <Form.Group
                            as={Col}
                            className="mb-3"
                            controlId="institutionName"
                          >
                            <Form.Label>
                              機構名稱 <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="institutionName"
                              value={values.institutionName}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              placeholder={initialValues.institutionName}
                              className={
                                touched.institutionName &&
                                errors.institutionName
                                  ? 'border border-danger border-2'
                                  : null
                              }
                            />
                            {touched.institutionName &&
                            errors.institutionName ? (
                              <div className="text-danger">
                                {errors.institutionName}
                              </div>
                            ) : null}
                          </Form.Group>

                          <Form.Group
                            as={Col}
                            className="mb-3"
                            controlId="contactPhone"
                          >
                            <Form.Label>
                              連絡電話<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="tel"
                              name="contactPhone"
                              value={values.contactPhone}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              placeholder={initialValues.contactPhone}
                              className={
                                touched.contactPhone && errors.contactPhone
                                  ? 'border border-danger border-2'
                                  : null
                              }
                            />
                            {touched.contactPhone && errors.contactPhone ? (
                              <div className="text-danger">
                                {errors.contactPhone}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Row>

                        <Form.Group className="mb-3" controlId="email">
                          <Form.Label>
                            Email<span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={values.email}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            placeholder={initialValues.email}
                            className={
                              touched.email && errors.email
                                ? 'border border-danger border-2'
                                : null
                            }
                          />
                          {touched.email && errors.email ? (
                            <div className="text-danger">{errors.email}</div>
                          ) : null}
                        </Form.Group>

                        <Row className="mb-3">
                          <Form.Group as={Col} controlId="city">
                            <Form.Label>
                              所在縣市<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              name="city"
                              value={values.city}
                              onBlur={handleBlur}
                              onChange={handleCityChange}
                              className={
                                touched.city && errors.city
                                  ? 'border border-danger border-2'
                                  : null
                              }
                            >
                              <option value="">{initialValues.city}</option>
                              {postalCodes.map((v, i) => {
                                return (
                                  <option key={i} value={v.city}>
                                    {v.city}
                                  </option>
                                )
                              })}
                            </Form.Select>
                            {touched.city && errors.city ? (
                              <div className="text-danger">{errors.city}</div>
                            ) : null}
                          </Form.Group>
                          <Form.Group as={Col} controlId="postalCode">
                            <Form.Label>
                              鄉鎮(市)區<span className="text-danger">*</span>
                            </Form.Label>

                            <Form.Select
                              name="dist"
                              value={values.dist}
                              onBlur={handleBlur}
                              onChange={handleDistChange}
                              className={
                                touched.dist && errors.dist
                                  ? 'border border-danger border-2'
                                  : null
                              }
                            >
                              <option value="">{initialValues.dist}</option>
                              {codes.map((v, i) => {
                                return (
                                  <option key={i} value={v}>
                                    {v}
                                  </option>
                                )
                              })}
                            </Form.Select>
                            {touched.dist && errors.dist ? (
                              <div className="text-danger">{errors.dist}</div>
                            ) : null}
                          </Form.Group>
                        </Row>
                        {errShow.show && (
                          <Alert
                            variant="danger"
                            onClose={() => setErrShow({ show: false, msg: '' })}
                            dismissible
                            className="fs-6"
                          >
                            <i className="fa-solid fa-triangle-exclamation"></i>{' '}
                            {errShow.msg}
                          </Alert>
                        )}
                        {success && (
                          <Alert
                            variant="success"
                            onClose={() => setSuccess(false)}
                            dismissible
                            className="fs-6"
                          >
                            <i className="fa-regular fa-face-smile"></i>
                            {'  '}
                            帳號更新成功！
                          </Alert>
                        )}

                        <div className="d-flex">
                          <Button
                            type="submit"
                            variant="primary"
                            className="ms-auto"
                            disabled={isSubmitting}
                          >
                            更新基本資料{' '}
                            <Spinner
                              as="span"
                              animation={isLoading ? 'border' : ''}
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          </Button>
                        </div>
                      </Form>
                    )
                  }}
                </Formik>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Settings
